import React, { useId } from "react";

import { useTranslation } from "react-i18next";

import SwitchOnOff from "../../../../components/common/tools/SwitchOnOff";
import { Field, FieldLabel } from "../../../../components/ui/field";
import { Input } from "../../../../components/ui/input";
import InfoTooltip from "../../../../components/utils/InfoTooltip";

import type { ChangeEvent, JSX } from "react";

interface ContentTrailerAutoplayComponentProps {
  isAutoplayed: boolean;
  delaySeconds: number | null;
  onChangeAutoplay: (isAutoplayed: boolean) => void;
  onChangeDelay: (delaySeconds: number | null) => void;
}

function ContentTrailerAutoplayComponent({
  isAutoplayed,
  delaySeconds,
  onChangeAutoplay,
  onChangeDelay,
}: ContentTrailerAutoplayComponentProps): JSX.Element {
  const { t } = useTranslation("editor-platform");
  const delayInputId = useId();

  const handleChangeDelay = (DOMEvent: ChangeEvent<HTMLInputElement>): void => {
    const { value } = DOMEvent.target;

    onChangeDelay(value === "" ? null : Number(value));
  };

  return (
    <div className="mb-2.5 flex flex-col pt-2.5">
      <div className="text-foreground py-1.25 text-[0.9375rem] font-medium">
        {t("trailerAutoplayLabel")}
      </div>
      <div className="flex items-center gap-3.75">
        <SwitchOnOff
          checked={isAutoplayed}
          name="trailer_autoplay"
          onChange={onChangeAutoplay}
          size="sm"
        />
        <div className="text-muted-foreground text-sm">
          {t("activateTrailerAutoplay")}
        </div>
        <InfoTooltip>{t("trailerAutoplayTooltip")}</InfoTooltip>
      </div>
      {isAutoplayed ? (
        <Field className="mt-2.5">
          <FieldLabel htmlFor={delayInputId}>
            {t("trailerAutoplayDelay")}
          </FieldLabel>
          <div className="flex items-center gap-3.75">
            <Input
              className="max-w-64"
              id={delayInputId}
              min={0}
              name="trailer_autoplay_delay"
              onChange={handleChangeDelay}
              placeholder={t("trailerAutoplayDelayPlaceholder")}
              step={1}
              type="number"
              value={delaySeconds ?? ""}
            />
            <InfoTooltip>{t("trailerAutoplayDelayDescription")}</InfoTooltip>
          </div>
        </Field>
      ) : null}
    </div>
  );
}

export default ContentTrailerAutoplayComponent;
